import {withTranslation} from "react-i18next";
import React, {useState, useEffect} from "react";
import {Backdrop, Fade, Grid, makeStyles, Modal} from '@material-ui/core';
import {onClickInstallUnisat, onClickUnisatWallet, onClickInstallOKX, onClickUnielonWallet, onClickInstallUnielon} from "../utils/Sign";
import { wallets } from '../constant'
import {isValidBtcAddress, isValidDogeAddress, formatChainIdNumber} from "../utils/Common";
import { authActions } from "../redux/actions";
import { useDispatch } from "react-redux";
import { useWalletStore } from '../store/useStore'

const WalletModal = (props) => {
    const {
        walletModalOpen,
        closeWalletModal,
        isMobile,
        handleNewAccounts,
        handleNewNetwork,
        handleNewChain,
        t
    } = props;
    const useStyles = makeStyles((theme) => ({
        modal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        paper: {
            backgroundColor: 'white',
            border: 'transparent',
            // boxShadow: theme.shadows[5],
            padding: theme.spacing(2, 4, 3),
            borderRadius: 20,
            textAlign: 'center'
        },
        walletBox: {
            padding: isMobile ? null : theme.spacing(2, 2),
            borderRadius: 5,
            cursor: 'pointer',
            '&:hover' : {
                backgroundColor: '#E0E0E0',
            }
        },
        walletIcon: {
            width: isMobile ? 30: 50,
            marginLeft: isMobile ? 12 :24,
            marginRight: isMobile ? 12 :24,

        },
        walletTitle: {
            fontWeight: 'bold',
            fontSize: isMobile ? 12 : 15,
            fontFamily:"Syncopate"

        },
        walletMsg: {
            textAlign: 'center',
            fontWeight: 'bold',
            fontSize: 12,
            width: '100%',
            fontFamily: "PingFang SC",
        }
    }));
    const classes = useStyles();
    const { address, setAddress, chainId, setChainId, network, setNetwork, pubKey, setPublicKey,
        walletDisconnected, setWalletDisconnected, dappConnected, setDappConnected, autoSign, setAutoSign,
        currentWallet, setWallet, startWatch, setStartWatch, button1, button2, setButton1, setButton2, setButton1Disabled, setButton2Disabled,
        button1Disabled, button2Disabled
    } = useWalletStore()
    const dispatch = useDispatch()
    const [msg, setMsg] = useState('')
    const [signedHash, setSignedHash] = useState('')
    const unisatLogin = async (wallet) => {
        let unisatResponse = await onClickUnisatWallet()
        if (unisatResponse.success) {
            let publicKey = await window.unisat.getPublicKey()
            handleNewAccounts(unisatResponse.addr)
            handleNewNetwork(unisatResponse.network)
            handleNewChain(Number(unisatResponse.chainId))
            setAutoSign(true)
            setPublicKey(publicKey)
            setDappConnected(true)
            let _chainIdNumber = formatChainIdNumber(unisatResponse.chainId)
            let payload = {
                address:typeof unisatResponse.addr === 'string' ? unisatResponse.addr : unisatResponse.addr[0], 
                chain: _chainIdNumber,
                network: unisatResponse.network, 
                wallet: wallet, 
                pbulicKey: publicKey
            }
            dispatch(authActions.saveWalletConfig(payload))
        } else {
            setMsg(unisatResponse.msg.message)
        }

        window.unisat.on('accountsChanged', (acct) => {

        });
        window.unisat.on('networkChanged', (network) => handleNewNetwork(network));
    }

    const okxBtcLogin = async (wallet) => {
        if (typeof window.okxwallet !== 'undefined') {
          try {
            let res = process.env.NEXT_PUBLIC_NETWORK === 'testnet' ? await window.okxwallet.bitcoinTestnet.connect() : await window.okxwallet.bitcoin.connect()
            if (isValidBtcAddress(res.address)) {
              let network = process.env.NEXT_PUBLIC_NETWORK === 'testnet' ? 'testnet' : await window.okxwallet.bitcoin.getNetwork()
              console.log('network: ', network)
              handleNewNetwork(network)
              handleNewChain(12321232123)
              handleNewAccounts(res.address)
              setAutoSign(true)
              setPublicKey(res.publicKey)
              setDappConnected(true)
              let payload = {
                address:res.address, 
                chain: 12321232123,
                network: network, 
                wallet: wallet, 
                pbulicKey: res.publicKey
            }
              dispatch(authActions.saveWalletConfig(payload))
            }
            console.log('okx btc acct connect res: ', res)
          } catch (err) {
            console.log('okx btc acct connect failed: ', err)
          }
        }
    }

    const unielonLogin = async (wallet) => {
        let unielonResponse = await onClickUnielonWallet()
        if (unielonResponse.success) {
            let publicKey = await window.unielon.getPublicKey()
            handleNewAccounts(unielonResponse.addr)
            handleNewNetwork(unielonResponse.network)
            handleNewChain(Number(unielonResponse.chainId))
            setAutoSign(true)
            setPublicKey(publicKey)
            setDappConnected(true)
            let _chainIdNumber = formatChainIdNumber(unielonResponse.chainId)
            let payload = {
                address:typeof unielonResponse.addr === 'string' ? unielonResponse.addr : unielonResponse.addr[0], 
                chain: _chainIdNumber,
                network: unielonResponse.network, 
                wallet: wallet, 
                pbulicKey: publicKey
            }
            dispatch(authActions.saveWalletConfig(payload))
        } else {
            setMsg(unielonResponse.msg.message)
        }

        window.unielon.on('accountsChanged', (acct) => {

        });
        window.unielon.on('networkChanged', (network) => handleNewNetwork(network));
    }

    const handleWallectConnect = async (wallet) => {
        setWallet(wallet)
        if (wallet.name === 'OKX Wallet') {
            if (typeof window !== 'undefined' && window.okxwallet === undefined) {
                onClickInstallOKX()
            } else {
                await okxBtcLogin(wallet);
            }
        } else if (wallet.name === 'Unisat') {
            if (typeof window !== 'undefined' && window.unisat === undefined) {
            onClickInstallUnisat();
            } else {
            await unisatLogin(wallet);
            }
        } else if (wallet.name === 'Unielon Wallet') {
            if (typeof window !== 'undefined' && window.unielon === undefined) {
                onClickInstallUnielon()
            } else {
                await unielonLogin(wallet);
            }
        }
        else {
            console.log('uncaught error !');
        }
    };


    return (
        <Modal
            open={walletModalOpen}
            onClose={() => {
                setMsg('')
                closeWalletModal()
            }}
            aria-labelledby="parent-modal-title"
            aria-describedby="parent-modal-description"
            className={classes.modal}
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={walletModalOpen}>
                <div className={classes.paper}>
                    <div className={classes.paper}>
                        <h2 id="parent-modal-title">{t('chooseWallet')}</h2>
                    </div>
                    <div className={classes.paper}>
                        <Grid container spacing={isMobile ? 3 : 5} columns={{ xs: 4, sm: 8, md: 12 }}  >
                            {
                                wallets.map(wallet => (
                                    <Grid item xs={6} key={wallet.alias}>
                                        <div className={classes.walletBox} >
                                            <img alt={wallet.alias} className={classes.walletIcon} src={wallet.icon} onClick={() => handleWallectConnect(wallet)} />
                                            <h2 className={classes.walletTitle}>{wallet.name}</h2>
                                        </div>
                                    </Grid>
                                ))
                            }
                            {/* <Grid item xs={6} >
                                <div className={classes.walletBox} >
                                    <img alt='' className={classes.walletIcon} src={OKX} onClick={!window.okxwallet  ? () => onClickInstall(sendBackButton1, sendBackButton1Disabled) : chainId === 0 ? () => initialize() : () => okxBtcLogin()} />
                                    <h2 className={classes.walletTitle}>OKX</h2>
                                </div>
                            </Grid>
                            <Grid item xs={6} >
                                <div className={classes.walletBox}>
                                    <img alt='' className={classes.walletIcon} src={UNISAT} onClick={
                                        window.unisat === undefined ? onClickInstallUnisat : unisatLogin
                                    } />
                                    <h2 className={classes.walletTitle}>UNISAT</h2>
                                </div>
                            </Grid> */}
                            {/* <Grid item xs={4} >
                                <div className={classes.walletBox} onClick={() => VerifyUnisatSignUsingNewBitcore(msg, signedHash)}>
                                    <img alt='' className={classes.walletIcon} src={UNISAT} />
                                    <h2 className={classes.walletTitle}>VERIFY UNISAT SIGN</h2>
                                </div>
                            </Grid> */}
                            {/* <Grid item xs={4} >
                                <div className={classes.walletBox} onClick={!window.ethereum  ? () => onClickInstall(sendBackButton1, sendBackButton1Disabled) : chainId === 0 ? () => initialize() : () => onClickConnect()}>
                                    <img alt='' className={classes.walletIcon} src={METAMASK} />
                                    <h2 className={classes.walletTitle}>METAMASK</h2>
                                </div>
                            </Grid> */}

                            {
                                msg !== '' ?
                                    <h2 className={classes.walletMsg}>{msg}</h2>

                                   : null
                            }
                        </Grid>
                    </div>
                </div>
            </Fade>
        </Modal>
    )
}

export default withTranslation()(WalletModal);
